// extracted by mini-css-extract-plugin
export var contianer = "page-title-module--contianer--e0zVt";
export var discription = "page-title-module--discription--Rg31d";
export var pageTitle = "page-title-module--pageTitle--jz9Xm";